import { InjectionToken } from '@angular/core';

export const SETUP_HELP_INFO_URL_INJECTION_TOKEN = new InjectionToken<string>(
  'com.vendasta.email-ui.domain-authorization.setup-help-info-url',
);
